<script>
import { authComputed } from "@/state/helpers";
import PageHeader from "@/components/page-header";
import DatePicker from "vue2-datepicker";
import errorHandler from "@/helpers/errorHandler";
import moment from "moment";
import Axios from "axios";
import Swal from "sweetalert2";
import Middleware from "@/helpers/middlewares";
import BookingService from "@/helpers/APIService/booking.service";

export default {
  components: {
    DatePicker,
    PageHeader,
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "submittedAndCancelSubmit", "cancelSubmit"],
  data() {
    return {
      title: "Bulk Booking",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Bulk Booking",
          active: true,
        },
      ],
      table: {
        tableData: [],
      },
      uploadDate: moment().format("YYYY-MM-DD"),
      image: "",
      logsData: [],
      is_data_loading: false,
      isBtnLoading: false,
    };
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getBulkBookingData();
  },
  methods: {
    // Method is use for get all payment method
    async getBulkBookingData() {
      await BookingService.getBulkBooking()
        .then((response) => {
          this.is_data_loading = true;
          this.table.tableData = response;
          this.is_data_loading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for open bulk upload model
    openUploadExcelModal() {
      this.$bvModal.show("bulk-booking-add-modal");
    },
    // Method is use for refresh API
    refreshPage() {
      this.getBulkBookingData();
    },
    // Method is use for maintained change image
    changeImage(event) {
      if (event.target.files[0] !== undefined) {
        this.image =
          event.target.files[0] == undefined ? null : event.target.files[0];
      }
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    // Bulk booking save and close form method
    handleSubmit() {
      this.isBtnLoading = true;
      const data = new FormData();
      data.append("hotel", this.hotel.id);
      data.append("excel_file", this.image);
      data.append("upload_date", this.uploadDate);
      BookingService.createBulkBooking(data)
        .then((response) => {
          this.table.tableData.unshift(response);
          Middleware.notification(
            "File uploaded successFully !!",
            "success",
            3000
          );
          this.isBtnLoading = false;
          this.$bvModal.hide("bulk-booking-add-modal");
        })
        .catch((error) => {
          this.isBtnLoading = false;
          errorHandler(error);
        });
    },
    // Method is use for reset modal value
    resetModal() {
      this.isBtnLoading = false;
      this.uploadDate = moment().format("YYYY-MM-DD");
    },
    // Method is use for show failed booking reference numbers
    showFailedBookingRef(data) {
      this.logsData = data;
      this.$bvModal.show("bulk-booking-failed-modal");
    },
    // Method is use for download excel
    downloadExcel(file) {
      Axios.get(file, { responseType: "blob" }).then((response) => {
        const blob = new Blob([response.data], {
          type: "application/vnd.ms-excel",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "bookingList";
        link.click();
        URL.revokeObjectURL(link.href);
      });
    },
    // Method is use for delete excel file
    deleteExcelFileById(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          BookingService.deleteExcelFile(id).then(
            (response) => {
              let index = this.table.tableData.findIndex((el) => el.id === id);
              this.table.tableData.splice(index, 1);
              Middleware.notification(
                "Successfully deleted !!",
                "danger",
                3000
              );
            },
            (error) => {
              errorHandler(error);
            }
          );
        }
      });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :items="items"
      :isButton="true"
      :multipleButtonData="[
        {
          text: 'Refresh',
          action: refreshPage,
        },
        {
          text: 'Upload File',
          action: openUploadExcelModal,
        },
      ]"
    />
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <!-- Table -->
            <div class="table-responsive mb-0" v-dragscroll>
              <table
                class="table table-hover mb-0"
                ref="my-table"
                v-infinite-scroll="getBulkBookingData"
                infinite-scroll-disabled="busy"
                infinite-scroll-distance="10"
              >
                <thead class="table-light">
                  <tr>
                    <th>Upload Date</th>
                    <th>Status</th>
                    <th>Total Booking</th>
                    <th>Completed</th>
                    <th>Failed</th>
                    <th>Pending</th>
                    <th>Updated By</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody
                  id="infinite-list"
                  v-if="table.tableData.length > 0 && !is_data_loading"
                >
                  <tr v-for="(data, index) in table.tableData" :key="index">
                    <td>{{ global_format_date(data.upload_date) }}</td>
                    <td>{{ data.status }}</td>
                    <td>{{ data.total_booking }}</td>
                    <td>{{ data.completed }}</td>
                    <td>{{ data.failed }}</td>
                    <td>{{ data.pending }}</td>
                    <td>
                      {{ data.updated_by !== null ? data.updated_by : "-" }}
                    </td>
                    <td>
                      <span
                        class="me-3"
                        @click="showFailedBookingRef(data.failed_booking_ref)"
                      >
                        <i
                          class="fas fa-eye"
                          v-b-popover.hover="'Failed Booking'"
                        >
                        </i>
                      </span>
                      <span
                        class="me-3"
                        @click.prevent="downloadExcel(data.excel_file)"
                      >
                        <i
                          class="fas fa-file-download"
                          v-b-popover.hover="'Download Excel'"
                        ></i>
                      </span>
                      <span class="me-3" @click="deleteExcelFileById(data.id)">
                        <i
                          class="mdi mdi-trash-can"
                          v-b-popover.hover="'Delete Excel'"
                        ></i>
                      </span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="is_data_loading">
                  <tr v-for="number in 20" :key="number">
                    <td class="placeholder-glow" v-for="no in 8" :key="no">
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="!is_data_loading && table.tableData.length == 0">
                  <tr>
                    <td colspan="12" class="text-center">
                      <img
                        src="@/assets/images/empty.svg"
                        class="img-fluid"
                        alt=""
                      />
                      <p>
                        <span class="text-secondary">No Data Found</span>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Model is for add  bulk upload -->
    <b-modal
      id="bulk-booking-add-modal"
      centered
      title="Upload Booking Excel"
      hide-footer
      title-class="font-18"
      @hidden="resetModal"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group label="file" label-for="file-input" class="mb-3">
          <p slot="label">Excel File</p>
          <b-form-file
            id="file-input"
            type="file"
            plain
            class="form-control"
            @change="changeImage($event)"
          ></b-form-file>
        </b-form-group>
        <b-form-group label="Upload Date" label-for="upload-date" class="mb-3">
          <date-picker
            id="upload-date"
            v-model="uploadDate"
            format="YYYY-MM-DD"
            value-type="format"
            type="date"
            placeholder="YYYY-MM-DD"
          ></date-picker>
        </b-form-group>
        <b-button
          class="float-end ms-2"
          variant="outline-primary"
          @click="handleOk"
          :class="{ disabled: isBtnLoading }"
        >
          <i
            v-if="isBtnLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i>
          Save
        </b-button>
      </form>
    </b-modal>

    <!-- Model is for show upload failed logs  -->
    <b-modal
      id="bulk-booking-failed-modal"
      title="Booking Failed Detail"
      title-class="font-18"
      centered
      hide-footer
    >
      <template>
        <div
          class="d-block failed_booking_info"
          v-for="(log, index) in logsData"
          :key="index"
        >
          <p class="text-danger">{{ log }}</p>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<style scoped>
.failed_booking_info {
  max-height: 340px;
  overflow: auto;
}
</style>
